import { createTeam, TEAM_FUNCTIONS } from './team.js';
/**
 * D850 (L5-008): the teams a country cannot run the Central without - the front line, the 24 h safety team and supervision (the fallback of every empty
 * team). A country whose registered default of one of these has nobody in it is not ready: a conversation would wait for a person who does not exist.
 */
export const MANDATORY_TEAM_FUNCTIONS = ['atendimento', 'seguranca', 'supervisao'];
/** Monday to Friday 08:00 to 18:00 and Saturday 08:00 to 12:00 on the market's local clock (owner Q-367). */
export const DEFAULT_BUSINESS_HOURS = [
    ...['MON', 'TUE', 'WED', 'THU', 'FRI'].map((day) => ({ day, start: '08:00', end: '18:00' })),
    { day: 'SAT', start: '08:00', end: '12:00' },
];
const ALL_CHANNELS = ['whatsapp', 'web_widget', 'mobile_app', 'voice'];
const TEXT_CHANNELS = ['whatsapp', 'web_widget', 'mobile_app'];
/**
 * The six templates. Atendimento answers every channel, the phone included; Seguranca is open 24 h on every channel;
 * the back-office functions answer the written channels; Supervisao (the coordinators) is not a contact queue.
 */
export const DEFAULT_TEAM_TEMPLATES = [
    { function: 'atendimento', alwaysOpen: false, weeklyHours: DEFAULT_BUSINESS_HOURS, channels: ALL_CHANNELS },
    { function: 'financeiro', alwaysOpen: false, weeklyHours: DEFAULT_BUSINESS_HOURS, channels: TEXT_CHANNELS },
    { function: 'comercial', alwaysOpen: false, weeklyHours: DEFAULT_BUSINESS_HOURS, channels: TEXT_CHANNELS },
    { function: 'cadastro_prestadores', alwaysOpen: false, weeklyHours: DEFAULT_BUSINESS_HOURS, channels: TEXT_CHANNELS },
    { function: 'seguranca', alwaysOpen: true, weeklyHours: [], channels: ALL_CHANNELS },
    { function: 'supervisao', alwaysOpen: false, weeklyHours: DEFAULT_BUSINESS_HOURS, channels: [] },
];
/**
 * The default teams still missing: the six functions of each country, minus the defaults that exist. Countries are taken in the
 * order given, functions in {@link TEAM_FUNCTIONS} order; a country with an invalid code or no language is skipped (it cannot
 * be served yet) and listed in `skipped`.
 */
export function ensureDefaultTeams(input) {
    const have = new Set(input.existing.filter((t) => t.isDefault).map((t) => `${t.countryCode}|${t.function}`));
    const create = [];
    const skipped = [];
    const seen = new Set();
    for (const country of input.countries) {
        if (seen.has(country.countryCode))
            continue;
        seen.add(country.countryCode);
        let produced = 0;
        for (const fn of TEAM_FUNCTIONS) {
            if (have.has(`${country.countryCode}|${fn}`))
                continue;
            const template = DEFAULT_TEAM_TEMPLATES.find((t) => t.function === fn);
            if (template === undefined)
                continue;
            const made = createTeam({ function: fn, countryCode: country.countryCode, languages: country.languages, weeklyHours: template.weeklyHours, alwaysOpen: template.alwaysOpen, channels: template.channels }, { teamId: input.newId(), at: input.at, actor: input.actor, isDefault: true });
            if (!made.ok) {
                skipped.push(country.countryCode);
                break;
            }
            create.push(made.value);
            produced += 1;
        }
        // A country that failed half-way keeps nothing partial: either all its missing defaults are planned or none is.
        if (skipped[skipped.length - 1] === country.countryCode && produced > 0)
            create.splice(create.length - produced, produced);
    }
    return { create, skipped };
}
//# sourceMappingURL=defaults.js.map